<div *ngIf="opportunity$ | async as opportunity">
  <div class="container">
    <div class="row title-content">
      <div class="row">
        <div class="col col-xs-12">
          {{
            'FRONTEND.SALES_UI.COMMON.DATES.CREATED_ON' | translate : { date: opportunity.created | date : 'MMM dd, y' }
          }}
        </div>
      </div>
    </div>

    <div class="row">
      <div id="left-opportunity-info-column">
        <sales-ui-opportunity-info-form></sales-ui-opportunity-info-form>
      </div>
      <div id="right-opportunity-info-column">
        <div class="projected-value">
          {{ opportunity.projectedFirstYearValue || 0 | formatCurrency : preferredCurrency }}
        </div>
        {{ 'FRONTEND.SALES_UI.SALES_OPPORTUNITIES.OPPORTUNITY_VALUE' | translate }}
        <div>
          <sales-ui-close-opportunity class="opportunity-close-actions"></sales-ui-close-opportunity>
        </div>
      </div>
    </div>
  </div>
</div>
